module.exports = __webpack_public_path__ + "assets/img/addservice.07029975.svg";